<template>
    <div>
        <div class="d-flex align-items-center mb-3">
            <div>
                <h1 class="page-header mb-0"><i class="fa-solid fa-file-signature"></i> Szakvizsgák</h1>
            </div>
            <div class="ms-auto">
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <panel title="Felhasználók">
                    <loading v-if="!users"></loading>
                    <no-records v-else-if="users.length == 0" main_icon="fa fa-file-signature" title="Nincs szakvizsgával rendelkező felhasználó"></no-records>
                    <div v-else class="table-responsive">
                        <table class="table">
                            <thead class="table-dark">
                                <tr>
                                    <th>Név</th>
                                    <th>Alap jogkör</th>
                                    <th>Szakvizsga típusa</th>
                                    <th>Szakvizsga száma</th>
                                    <th>Szakvizsga érvényessége</th>
                                    <th>Mentés</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(user,id) in users">
                                    <tr v-for="(permit,pid) in user.permits" :key="id+'-'+pid">
                                        <td>{{ user.name }}</td>
                                        <td>{{ user.role_name }}</td>
                                        <td>{{ user_permit_types.find(pt => pt.id == permit.user_permit_type)['name'] }}</td>
                                        <td><input type="text" class="form-control" v-model="permit.certificate_number"></td>
                                        <td><input type="date" class="form-control" v-model="permit.certificate_valid_until"></td>
                                        <td><button class="btn btn-success" @click="updateUserPermit(permit)"><i class="fa fa-save"></i></button></td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </panel>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from '../../components/Loading';
import NoRecords from '../../components/NoRecords';
import User from '../../apis/User';

export default {
    components: {
        Loading, NoRecords
    },
    data() {
        return {
            users:null,
            user_permit_types: JSON.parse(localStorage.getItem('constants')).user_permit_types,
        }
    },
    created() {
        User.usersWithPermits().then(response => {
            this.users = response.data;
        });

    },
    methods: {
        updateUserPermit(userpermit){
            User.updateUserPermit(userpermit.id, {
                certificate_number: userpermit.certificate_number,
                certificate_valid_until: userpermit.certificate_valid_until,
            });
        }
    }
}
</script>